/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { factorClientsGet } from '../fn/factor/factor-clients-get';
import { FactorClientsGet$Params } from '../fn/factor/factor-clients-get';
import { factorClientsGet$Plain } from '../fn/factor/factor-clients-get-plain';
import { FactorClientsGet$Plain$Params } from '../fn/factor/factor-clients-get-plain';
import { factorDocumentPerDayGet } from '../fn/factor/factor-document-per-day-get';
import { FactorDocumentPerDayGet$Params } from '../fn/factor/factor-document-per-day-get';
import { factorDocumentPerDayGet$Plain } from '../fn/factor/factor-document-per-day-get-plain';
import { FactorDocumentPerDayGet$Plain$Params } from '../fn/factor/factor-document-per-day-get-plain';
import { factorDownloadByLayoutGet } from '../fn/factor/factor-download-by-layout-get';
import { FactorDownloadByLayoutGet$Params } from '../fn/factor/factor-download-by-layout-get';
import { factorFilteredSubmissionsCustomerReportCompeletedGet } from '../fn/factor/factor-filtered-submissions-customer-report-compeleted-get';
import { FactorFilteredSubmissionsCustomerReportCompeletedGet$Params } from '../fn/factor/factor-filtered-submissions-customer-report-compeleted-get';
import { factorFilteredSubmissionsCustomerReportCompeletedGet$Plain } from '../fn/factor/factor-filtered-submissions-customer-report-compeleted-get-plain';
import { FactorFilteredSubmissionsCustomerReportCompeletedGet$Plain$Params } from '../fn/factor/factor-filtered-submissions-customer-report-compeleted-get-plain';
import { factorFilteredSubmissionsCustomerReportGet } from '../fn/factor/factor-filtered-submissions-customer-report-get';
import { FactorFilteredSubmissionsCustomerReportGet$Params } from '../fn/factor/factor-filtered-submissions-customer-report-get';
import { factorFilteredSubmissionsCustomerReportGet$Plain } from '../fn/factor/factor-filtered-submissions-customer-report-get-plain';
import { FactorFilteredSubmissionsCustomerReportGet$Plain$Params } from '../fn/factor/factor-filtered-submissions-customer-report-get-plain';
import { factorFilteredSubmissionsGet } from '../fn/factor/factor-filtered-submissions-get';
import { FactorFilteredSubmissionsGet$Params } from '../fn/factor/factor-filtered-submissions-get';
import { factorFilteredSubmissionsGet$Plain } from '../fn/factor/factor-filtered-submissions-get-plain';
import { FactorFilteredSubmissionsGet$Plain$Params } from '../fn/factor/factor-filtered-submissions-get-plain';
import { factorFilteredSubmissionsWithClientsGet } from '../fn/factor/factor-filtered-submissions-with-clients-get';
import { FactorFilteredSubmissionsWithClientsGet$Params } from '../fn/factor/factor-filtered-submissions-with-clients-get';
import { factorFilteredSubmissionsWithClientsGet$Plain } from '../fn/factor/factor-filtered-submissions-with-clients-get-plain';
import { FactorFilteredSubmissionsWithClientsGet$Plain$Params } from '../fn/factor/factor-filtered-submissions-with-clients-get-plain';
import { factorHitlPercentagePerDayGet } from '../fn/factor/factor-hitl-percentage-per-day-get';
import { FactorHitlPercentagePerDayGet$Params } from '../fn/factor/factor-hitl-percentage-per-day-get';
import { factorHitlPercentagePerDayGet$Plain } from '../fn/factor/factor-hitl-percentage-per-day-get-plain';
import { FactorHitlPercentagePerDayGet$Plain$Params } from '../fn/factor/factor-hitl-percentage-per-day-get-plain';
import { factorHitlReportGet } from '../fn/factor/factor-hitl-report-get';
import { FactorHitlReportGet$Params } from '../fn/factor/factor-hitl-report-get';
import { factorHitlReportGet$Plain } from '../fn/factor/factor-hitl-report-get-plain';
import { FactorHitlReportGet$Plain$Params } from '../fn/factor/factor-hitl-report-get-plain';
import { factorHitlSubmissionsPerDayGet } from '../fn/factor/factor-hitl-submissions-per-day-get';
import { FactorHitlSubmissionsPerDayGet$Params } from '../fn/factor/factor-hitl-submissions-per-day-get';
import { factorHitlSubmissionsPerDayGet$Plain } from '../fn/factor/factor-hitl-submissions-per-day-get-plain';
import { FactorHitlSubmissionsPerDayGet$Plain$Params } from '../fn/factor/factor-hitl-submissions-per-day-get-plain';
import { factorPagePerDayGet } from '../fn/factor/factor-page-per-day-get';
import { FactorPagePerDayGet$Params } from '../fn/factor/factor-page-per-day-get';
import { factorPagePerDayGet$Plain } from '../fn/factor/factor-page-per-day-get-plain';
import { FactorPagePerDayGet$Plain$Params } from '../fn/factor/factor-page-per-day-get-plain';
import { factorSubmissionsByBlockGet } from '../fn/factor/factor-submissions-by-block-get';
import { FactorSubmissionsByBlockGet$Params } from '../fn/factor/factor-submissions-by-block-get';
import { factorSubmissionsByBlockGet$Plain } from '../fn/factor/factor-submissions-by-block-get-plain';
import { FactorSubmissionsByBlockGet$Plain$Params } from '../fn/factor/factor-submissions-by-block-get-plain';
import { factorSubmissionsByFieldGet } from '../fn/factor/factor-submissions-by-field-get';
import { FactorSubmissionsByFieldGet$Params } from '../fn/factor/factor-submissions-by-field-get';
import { factorSubmissionsByFieldGet$Plain } from '../fn/factor/factor-submissions-by-field-get-plain';
import { FactorSubmissionsByFieldGet$Plain$Params } from '../fn/factor/factor-submissions-by-field-get-plain';
import { factorSubmissionsByLayoutGet } from '../fn/factor/factor-submissions-by-layout-get';
import { FactorSubmissionsByLayoutGet$Params } from '../fn/factor/factor-submissions-by-layout-get';
import { factorSubmissionsByLayoutGet$Plain } from '../fn/factor/factor-submissions-by-layout-get-plain';
import { FactorSubmissionsByLayoutGet$Plain$Params } from '../fn/factor/factor-submissions-by-layout-get-plain';
import { factorSubmissionsClientByBlockGet } from '../fn/factor/factor-submissions-client-by-block-get';
import { FactorSubmissionsClientByBlockGet$Params } from '../fn/factor/factor-submissions-client-by-block-get';
import { factorSubmissionsClientByBlockGet$Plain } from '../fn/factor/factor-submissions-client-by-block-get-plain';
import { FactorSubmissionsClientByBlockGet$Plain$Params } from '../fn/factor/factor-submissions-client-by-block-get-plain';
import { factorSubmissionsPerDayGet } from '../fn/factor/factor-submissions-per-day-get';
import { FactorSubmissionsPerDayGet$Params } from '../fn/factor/factor-submissions-per-day-get';
import { factorSubmissionsPerDayGet$Plain } from '../fn/factor/factor-submissions-per-day-get-plain';
import { FactorSubmissionsPerDayGet$Plain$Params } from '../fn/factor/factor-submissions-per-day-get-plain';
import { factorSyncRowDataWithElasticGet } from '../fn/factor/factor-sync-row-data-with-elastic-get';
import { FactorSyncRowDataWithElasticGet$Params } from '../fn/factor/factor-sync-row-data-with-elastic-get';
import { factorSyncRowDataWithElasticGet$Plain } from '../fn/factor/factor-sync-row-data-with-elastic-get-plain';
import { FactorSyncRowDataWithElasticGet$Plain$Params } from '../fn/factor/factor-sync-row-data-with-elastic-get-plain';
import { factorTotalsTodayGet } from '../fn/factor/factor-totals-today-get';
import { FactorTotalsTodayGet$Params } from '../fn/factor/factor-totals-today-get';
import { factorTotalsTodayGet$Plain } from '../fn/factor/factor-totals-today-get-plain';
import { FactorTotalsTodayGet$Plain$Params } from '../fn/factor/factor-totals-today-get-plain';
import { factorUserPerDayGet } from '../fn/factor/factor-user-per-day-get';
import { FactorUserPerDayGet$Params } from '../fn/factor/factor-user-per-day-get';
import { factorUserPerDayGet$Plain } from '../fn/factor/factor-user-per-day-get-plain';
import { FactorUserPerDayGet$Plain$Params } from '../fn/factor/factor-user-per-day-get-plain';
import { SubmissionsByDateDto } from '../models/submissions-by-date-dto';
import { SubmissionsGraphDto } from '../models/submissions-graph-dto';
import { SubmissionsGraphsDto } from '../models/submissions-graphs-dto';
import { SubmissionsGraphsWithClientsDto } from '../models/submissions-graphs-with-clients-dto';
import { SubmissionsHitlReportDto } from '../models/submissions-hitl-report-dto';
import { TotalsDto } from '../models/totals-dto';

@Injectable({ providedIn: 'root' })
export class FactorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `factorClientsGet()` */
  static readonly FactorClientsGetPath = '/Factor/clients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorClientsGet$Plain$Response(params?: FactorClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return factorClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorClientsGet$Plain(params?: FactorClientsGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.factorClientsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorClientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorClientsGet$Response(params?: FactorClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return factorClientsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorClientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorClientsGet(params?: FactorClientsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.factorClientsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `factorUserPerDayGet()` */
  static readonly FactorUserPerDayGetPath = '/Factor/user-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorUserPerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorUserPerDayGet$Plain$Response(params?: FactorUserPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorUserPerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorUserPerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorUserPerDayGet$Plain(params?: FactorUserPerDayGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorUserPerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorUserPerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorUserPerDayGet$Response(params?: FactorUserPerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorUserPerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorUserPerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorUserPerDayGet(params?: FactorUserPerDayGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorUserPerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorHitlReportGet()` */
  static readonly FactorHitlReportGetPath = '/Factor/hitl-report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorHitlReportGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlReportGet$Plain$Response(params?: FactorHitlReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsHitlReportDto>>> {
    return factorHitlReportGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorHitlReportGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlReportGet$Plain(params?: FactorHitlReportGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsHitlReportDto>> {
    return this.factorHitlReportGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsHitlReportDto>>): Array<SubmissionsHitlReportDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorHitlReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlReportGet$Response(params?: FactorHitlReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsHitlReportDto>>> {
    return factorHitlReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorHitlReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlReportGet(params?: FactorHitlReportGet$Params, context?: HttpContext): Observable<Array<SubmissionsHitlReportDto>> {
    return this.factorHitlReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsHitlReportDto>>): Array<SubmissionsHitlReportDto> => r.body)
    );
  }

  /** Path part for operation `factorSubmissionsPerDayGet()` */
  static readonly FactorSubmissionsPerDayGetPath = '/Factor/submissions-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsPerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsPerDayGet$Plain$Response(params?: FactorSubmissionsPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsPerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsPerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsPerDayGet$Plain(params?: FactorSubmissionsPerDayGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsPerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsPerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsPerDayGet$Response(params?: FactorSubmissionsPerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsPerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsPerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsPerDayGet(params?: FactorSubmissionsPerDayGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsPerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorDocumentPerDayGet()` */
  static readonly FactorDocumentPerDayGetPath = '/Factor/document-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorDocumentPerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorDocumentPerDayGet$Plain$Response(params?: FactorDocumentPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorDocumentPerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorDocumentPerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorDocumentPerDayGet$Plain(params?: FactorDocumentPerDayGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorDocumentPerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorDocumentPerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorDocumentPerDayGet$Response(params?: FactorDocumentPerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorDocumentPerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorDocumentPerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorDocumentPerDayGet(params?: FactorDocumentPerDayGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorDocumentPerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorPagePerDayGet()` */
  static readonly FactorPagePerDayGetPath = '/Factor/page-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorPagePerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorPagePerDayGet$Plain$Response(params?: FactorPagePerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorPagePerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorPagePerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorPagePerDayGet$Plain(params?: FactorPagePerDayGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorPagePerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorPagePerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorPagePerDayGet$Response(params?: FactorPagePerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorPagePerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorPagePerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorPagePerDayGet(params?: FactorPagePerDayGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorPagePerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorHitlSubmissionsPerDayGet()` */
  static readonly FactorHitlSubmissionsPerDayGetPath = '/Factor/hitl-submissions-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorHitlSubmissionsPerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlSubmissionsPerDayGet$Plain$Response(params?: FactorHitlSubmissionsPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorHitlSubmissionsPerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorHitlSubmissionsPerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlSubmissionsPerDayGet$Plain(params?: FactorHitlSubmissionsPerDayGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorHitlSubmissionsPerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorHitlSubmissionsPerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlSubmissionsPerDayGet$Response(params?: FactorHitlSubmissionsPerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorHitlSubmissionsPerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorHitlSubmissionsPerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlSubmissionsPerDayGet(params?: FactorHitlSubmissionsPerDayGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorHitlSubmissionsPerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorHitlPercentagePerDayGet()` */
  static readonly FactorHitlPercentagePerDayGetPath = '/Factor/hitl-percentage-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorHitlPercentagePerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlPercentagePerDayGet$Plain$Response(params?: FactorHitlPercentagePerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorHitlPercentagePerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorHitlPercentagePerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlPercentagePerDayGet$Plain(params?: FactorHitlPercentagePerDayGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorHitlPercentagePerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorHitlPercentagePerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlPercentagePerDayGet$Response(params?: FactorHitlPercentagePerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorHitlPercentagePerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorHitlPercentagePerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorHitlPercentagePerDayGet(params?: FactorHitlPercentagePerDayGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorHitlPercentagePerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorSubmissionsClientByBlockGet()` */
  static readonly FactorSubmissionsClientByBlockGetPath = '/Factor/submissions-client-by-block';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsClientByBlockGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsClientByBlockGet$Plain$Response(params?: FactorSubmissionsClientByBlockGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsByDateDto>>> {
    return factorSubmissionsClientByBlockGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsClientByBlockGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsClientByBlockGet$Plain(params?: FactorSubmissionsClientByBlockGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsByDateDto>> {
    return this.factorSubmissionsClientByBlockGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsByDateDto>>): Array<SubmissionsByDateDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsClientByBlockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsClientByBlockGet$Response(params?: FactorSubmissionsClientByBlockGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsByDateDto>>> {
    return factorSubmissionsClientByBlockGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsClientByBlockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsClientByBlockGet(params?: FactorSubmissionsClientByBlockGet$Params, context?: HttpContext): Observable<Array<SubmissionsByDateDto>> {
    return this.factorSubmissionsClientByBlockGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsByDateDto>>): Array<SubmissionsByDateDto> => r.body)
    );
  }

  /** Path part for operation `factorSubmissionsByBlockGet()` */
  static readonly FactorSubmissionsByBlockGetPath = '/Factor/submissions-by-block';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsByBlockGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByBlockGet$Plain$Response(params?: FactorSubmissionsByBlockGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsByBlockGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsByBlockGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByBlockGet$Plain(params?: FactorSubmissionsByBlockGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsByBlockGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsByBlockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByBlockGet$Response(params?: FactorSubmissionsByBlockGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsByBlockGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsByBlockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByBlockGet(params?: FactorSubmissionsByBlockGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsByBlockGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorSubmissionsByLayoutGet()` */
  static readonly FactorSubmissionsByLayoutGetPath = '/Factor/submissions-by-layout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsByLayoutGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByLayoutGet$Plain$Response(params?: FactorSubmissionsByLayoutGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsByLayoutGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsByLayoutGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByLayoutGet$Plain(params?: FactorSubmissionsByLayoutGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsByLayoutGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsByLayoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByLayoutGet$Response(params?: FactorSubmissionsByLayoutGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsByLayoutGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsByLayoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByLayoutGet(params?: FactorSubmissionsByLayoutGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsByLayoutGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorDownloadByLayoutGet()` */
  static readonly FactorDownloadByLayoutGetPath = '/Factor/download-by-layout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorDownloadByLayoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorDownloadByLayoutGet$Response(params?: FactorDownloadByLayoutGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return factorDownloadByLayoutGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorDownloadByLayoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorDownloadByLayoutGet(params?: FactorDownloadByLayoutGet$Params, context?: HttpContext): Observable<void> {
    return this.factorDownloadByLayoutGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `factorSubmissionsByFieldGet()` */
  static readonly FactorSubmissionsByFieldGetPath = '/Factor/submissions-by-field';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsByFieldGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByFieldGet$Plain$Response(params?: FactorSubmissionsByFieldGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsByFieldGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsByFieldGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByFieldGet$Plain(params?: FactorSubmissionsByFieldGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsByFieldGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSubmissionsByFieldGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByFieldGet$Response(params?: FactorSubmissionsByFieldGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
    return factorSubmissionsByFieldGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSubmissionsByFieldGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSubmissionsByFieldGet(params?: FactorSubmissionsByFieldGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphDto>> {
    return this.factorSubmissionsByFieldGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphDto>>): Array<SubmissionsGraphDto> => r.body)
    );
  }

  /** Path part for operation `factorFilteredSubmissionsCustomerReportGet()` */
  static readonly FactorFilteredSubmissionsCustomerReportGetPath = '/Factor/filtered-submissions-customer-report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsCustomerReportGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportGet$Plain$Response(params?: FactorFilteredSubmissionsCustomerReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
    return factorFilteredSubmissionsCustomerReportGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsCustomerReportGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportGet$Plain(params?: FactorFilteredSubmissionsCustomerReportGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsDto>> {
    return this.factorFilteredSubmissionsCustomerReportGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsDto>>): Array<SubmissionsGraphsDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsCustomerReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportGet$Response(params?: FactorFilteredSubmissionsCustomerReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
    return factorFilteredSubmissionsCustomerReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsCustomerReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportGet(params?: FactorFilteredSubmissionsCustomerReportGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsDto>> {
    return this.factorFilteredSubmissionsCustomerReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsDto>>): Array<SubmissionsGraphsDto> => r.body)
    );
  }

  /** Path part for operation `factorFilteredSubmissionsCustomerReportCompeletedGet()` */
  static readonly FactorFilteredSubmissionsCustomerReportCompeletedGetPath = '/Factor/filtered-submissions-customer-report-compeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsCustomerReportCompeletedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportCompeletedGet$Plain$Response(params?: FactorFilteredSubmissionsCustomerReportCompeletedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
    return factorFilteredSubmissionsCustomerReportCompeletedGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsCustomerReportCompeletedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportCompeletedGet$Plain(params?: FactorFilteredSubmissionsCustomerReportCompeletedGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsDto>> {
    return this.factorFilteredSubmissionsCustomerReportCompeletedGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsDto>>): Array<SubmissionsGraphsDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsCustomerReportCompeletedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportCompeletedGet$Response(params?: FactorFilteredSubmissionsCustomerReportCompeletedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
    return factorFilteredSubmissionsCustomerReportCompeletedGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsCustomerReportCompeletedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsCustomerReportCompeletedGet(params?: FactorFilteredSubmissionsCustomerReportCompeletedGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsDto>> {
    return this.factorFilteredSubmissionsCustomerReportCompeletedGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsDto>>): Array<SubmissionsGraphsDto> => r.body)
    );
  }

  /** Path part for operation `factorFilteredSubmissionsGet()` */
  static readonly FactorFilteredSubmissionsGetPath = '/Factor/filtered-submissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsGet$Plain$Response(params?: FactorFilteredSubmissionsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
    return factorFilteredSubmissionsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsGet$Plain(params?: FactorFilteredSubmissionsGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsDto>> {
    return this.factorFilteredSubmissionsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsDto>>): Array<SubmissionsGraphsDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsGet$Response(params?: FactorFilteredSubmissionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
    return factorFilteredSubmissionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsGet(params?: FactorFilteredSubmissionsGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsDto>> {
    return this.factorFilteredSubmissionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsDto>>): Array<SubmissionsGraphsDto> => r.body)
    );
  }

  /** Path part for operation `factorFilteredSubmissionsWithClientsGet()` */
  static readonly FactorFilteredSubmissionsWithClientsGetPath = '/Factor/filtered-submissions-with-clients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsWithClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsWithClientsGet$Plain$Response(params?: FactorFilteredSubmissionsWithClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsWithClientsDto>>> {
    return factorFilteredSubmissionsWithClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsWithClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsWithClientsGet$Plain(params?: FactorFilteredSubmissionsWithClientsGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsWithClientsDto>> {
    return this.factorFilteredSubmissionsWithClientsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsWithClientsDto>>): Array<SubmissionsGraphsWithClientsDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorFilteredSubmissionsWithClientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsWithClientsGet$Response(params?: FactorFilteredSubmissionsWithClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsWithClientsDto>>> {
    return factorFilteredSubmissionsWithClientsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorFilteredSubmissionsWithClientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorFilteredSubmissionsWithClientsGet(params?: FactorFilteredSubmissionsWithClientsGet$Params, context?: HttpContext): Observable<Array<SubmissionsGraphsWithClientsDto>> {
    return this.factorFilteredSubmissionsWithClientsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsGraphsWithClientsDto>>): Array<SubmissionsGraphsWithClientsDto> => r.body)
    );
  }

  /** Path part for operation `factorTotalsTodayGet()` */
  static readonly FactorTotalsTodayGetPath = '/Factor/totals-today';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorTotalsTodayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorTotalsTodayGet$Plain$Response(params?: FactorTotalsTodayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TotalsDto>> {
    return factorTotalsTodayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorTotalsTodayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorTotalsTodayGet$Plain(params?: FactorTotalsTodayGet$Plain$Params, context?: HttpContext): Observable<TotalsDto> {
    return this.factorTotalsTodayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<TotalsDto>): TotalsDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorTotalsTodayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorTotalsTodayGet$Response(params?: FactorTotalsTodayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TotalsDto>> {
    return factorTotalsTodayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorTotalsTodayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorTotalsTodayGet(params?: FactorTotalsTodayGet$Params, context?: HttpContext): Observable<TotalsDto> {
    return this.factorTotalsTodayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TotalsDto>): TotalsDto => r.body)
    );
  }

  /** Path part for operation `factorSyncRowDataWithElasticGet()` */
  static readonly FactorSyncRowDataWithElasticGetPath = '/Factor/sync-row-data-with-elastic';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSyncRowDataWithElasticGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSyncRowDataWithElasticGet$Plain$Response(params?: FactorSyncRowDataWithElasticGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return factorSyncRowDataWithElasticGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSyncRowDataWithElasticGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSyncRowDataWithElasticGet$Plain(params?: FactorSyncRowDataWithElasticGet$Plain$Params, context?: HttpContext): Observable<string> {
    return this.factorSyncRowDataWithElasticGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `factorSyncRowDataWithElasticGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSyncRowDataWithElasticGet$Response(params?: FactorSyncRowDataWithElasticGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return factorSyncRowDataWithElasticGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `factorSyncRowDataWithElasticGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  factorSyncRowDataWithElasticGet(params?: FactorSyncRowDataWithElasticGet$Params, context?: HttpContext): Observable<string> {
    return this.factorSyncRowDataWithElasticGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
